import { logger } from '@/utils/logger';

function setupCSPReporting(): void {
  if (typeof window === 'undefined') return;

  document.addEventListener('securitypolicyviolation', (event) => {
    logger.error('CSP Violation detected', {
      violatedDirective: event.violatedDirective,
      blockedURI: event.blockedURI,
      lineNumber: event.lineNumber,
      sourceFile: event.sourceFile,
      originalPolicy: event.originalPolicy,
    });

    if (import.meta.env.DEV) {
      logger.error('CSP Violation:', {
        directive: event.violatedDirective,
        blocked: event.blockedURI,
        file: event.sourceFile,
        line: event.lineNumber,
      });
    }
  });
}

export function setupGlobalErrorHandling() {
  setupCSPReporting();

  window.addEventListener('error', (event) => {
    logger.error('Global JavaScript error', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    logger.error('Unhandled promise rejection', {
      reason: event.reason,
    });
  });
}
